application.register("lib-autosize", class extends Stimulus.Controller {
    connect() {
        importScript(cdnjs.autosize, () => {
            autosize(this.element);
        });
    }
});